/**
 * @desc 埋点
 * 商家会员一期：https://omega.intra.didiglobal.com/ba/point/DemandPrd?nav=4&id=3335
 */
import trackEvent from '@/common/js/track.js'

// 商家会员绑定页面曝光
export function sailing_c_x_shop_b_membership_page_sw(attrs, callback) {
  trackEvent({
    eventId: 'sailing_c_x_shop_b_membership_page_sw',
    eventLabel: '商家会员绑定页面曝光',
    attrs,
    callback,
  })
}

// 商家会员绑定页面绑定按钮点击
export function sailing_c_x_shop_b_membership_page_link_ck(attrs, callback) {
  trackEvent({
    eventId: 'sailing_c_x_shop_b_membership_page_link_ck',
    eventLabel: '商家会员绑定页面绑定按钮点击',
    attrs,
    callback,
  })
}

// 商家会员绑定页面解绑二次确认弹窗曝光
export function sailing_c_x_shop_b_membership_page_popup_sw(attrs, callback) {
  trackEvent({
    eventId: 'sailing_c_x_shop_b_membership_page_popup_sw',
    eventLabel: '商家会员绑定页面解绑二次确认弹窗曝光',
    attrs,
    callback,
  })
}

// 商家会员绑定页面解绑二次确认弹窗点击
export function sailing_c_x_shop_b_membership_page_popup_ck(attrs, callback) {
  trackEvent({
    eventId: 'sailing_c_x_shop_b_membership_page_popup_ck',
    eventLabel: '商家会员绑定页面解绑二次确认弹窗点击',
    attrs,
    callback,
  })
}
